export default class PoliticaHoraExtra {
    constructor() {
        this.id = null;
        this.descricao = null;       
        this.descontoDSRFeriado = false;       
        this.toleranciaInicioHoraExtra = null;       
        // Prioridade hora extra: 1 banco horas, 2 horas extras
        this.prioridadeHoraExtra = null;
        this.faixasHoraExtra = [];
        this.horaExtraRefeicao = false;
    }    
}